<!-- =========================================================================================
    File Name: TablePagination.vue
    Description: Add pagination to table for long data
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-table max-items="15" pagination :data="customerHistory">

    <template slot="thead">
      <vs-th>First Name</vs-th>
      <vs-th>Last Name</vs-th>
      <vs-th>Email</vs-th>
      <vs-th>City</vs-th>
      <vs-th>State</vs-th>
      <vs-th>Country</vs-th>
      <vs-th>Zip</vs-th>
      <vs-th>Date</vs-th>
    </template>

    <template slot-scope="{data}" >
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="tr.firstname">
          {{ tr.firstname }}
        </vs-td>
        <vs-td :data="tr.lastname">
          {{ tr.lastname }}
        </vs-td>
        <vs-td :data="tr.email">
          {{ tr.email }}
        </vs-td>
        <vs-td :data="tr.city">
          {{ tr.city }}
        </vs-td>
        <vs-td :data="tr.state">
          {{ tr.state }}
        </vs-td>
        <vs-td :data="tr.country">
          {{ tr.country }}
        </vs-td>
        <vs-td :data="tr.zip">
          {{ tr.zip }}
        </vs-td>
        <vs-td :data="tr.date">
          <p class="product-date">{{ getFormatedDate(tr.date) }}</p>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
export default {
  computed: {
    customerHistory () {
      if('customerHistory' in this.$store.state.AppActiveUser.cards){
        return this.$store.state.AppActiveUser.cards.customerHistory
      } else {            
        this.$store.commit('UPDATE_CUSTOMER_HISTORY', this.$store.state.AppActiveUser.defaultState.cards.customerHistory)
        return this.$store.state.AppActiveUser.defaultState.cards.customerHistory
      }
    },
  },
  methods: {
    getOrderStatusColor (status) {
      if (status === 'cancelled' || status === 'pending' || status === 'refunded')   return 'dark'
      if (status === 'completed') return 'primary'
      if (status === 'processing')   return 'success'
      if (status === 'on_hold') return 'warning'
      if (status === 'failed')  return 'danger'
      return 'warning'
    },
    getFormatedDate(thedate) {  
      var dt = new Date( Number(thedate) );
      var dd = dt.getDate();
      var mm = dt.getMonth() + 1; //January is 0!
      var yyyy = dt.getFullYear();
      if (dd < 10) { dd = '0' + dd; } 
      if (mm < 10) { mm = '0' + mm; } 
      
      return mm + '-' + dd + '-' + yyyy + " " + dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    },
  },
}
</script>
